import clsx from "clsx";
import { ReactElement } from "react";

export default function MetricCard({
  metricName,
  metricData,
  icon,
  className,
}: {
  className?: string;
  metricName: string;
  metricData: string | number | ReactElement;
  icon?: ReactElement;
}) {
  return (
    <div
      className={clsx(
        "my-4 min-w-[320px] max-w-screen-xxs rounded-3xl bg-[#040910] px-10 pb-8 pt-3 font-satoshi shadow-[13px_17px_50px_0px_rgba(0,0,0,1),_20px_20px_100px_-40px_rgba(255,255,255,0.2)] transition-transform hover:scale-125 hover:border-1 hover:border-white",
        className || "",
      )}
    >
      <h3 className="my-2 text-xl font-medium underline underline-offset-8">{metricName}</h3>
      <div className="mt-4 text-7xl font-black">
        {typeof metricData === "number" ? `${metricData}`.padStart(2, "0") : metricData}
      </div>
      {icon ? <div className="float-right -mr-2 -mt-20">{icon}</div> : null}
    </div>
  );
}
